<script lang="ts">
import { modalRegister } from '@/services/modals';
import TaskGeneratorPullChangesModal from './TaskGeneratorPullChangesModal.vue';

export async function taskGeneratorPullChangesModal() {
  return modalRegister({
    content: TaskGeneratorPullChangesModal,
    bindings: {},
  });
}
</script>

<script setup lang="ts">
import BootstrapModal from '@/components/modals/BootstrapModal.vue';
import { ref } from 'vue';

const updateTasks = ref(false);
const modal = ref<InstanceType<typeof BootstrapModal> | null>(null);

defineExpose({ modal });
</script>

<template>
  <BootstrapModal ref="modal" title="Pull Template Changes" :defaultCloseValue="{ update: false, updateTasks }">
    <div>
      <label class="form-label">Push changes to existing tasks?</label>
      <select class="form-select" v-model="updateTasks">
        <option :value="false">Don't update tasks.</option>
        <option :value="true">Update tasks.</option>
      </select>
    </div>

    <template #footer="{ close }">
      <button class="btn btn-primary" @click="close({ update: true, updateTasks })">Update</button>
      <button class="btn btn-secondary" @click="close({ update: false, updateTasks })">Cancel</button>
    </template>
  </BootstrapModal>
</template>
